/**
 * Translation keys for /go/* ad landing pages.
 * Human-readable keys (not Framer XLIFF IDs) since this is new content.
 */
export const goKeys = {
  // ─── Shared trust features ───
  trustMriReviewed: "trustMriReviewed",
  trustMriConditions: "trustMriConditions",
  trustMriFollowUp: "trustMriFollowUp",
  trustMriFastResults: "trustMriFastResults",
  trustBloodReviewed: "trustBloodReviewed",
  trustBloodBiomarkers: "trustBloodBiomarkers",
  trustBloodPersonalized: "trustBloodPersonalized",
  trustBloodFastResults: "trustBloodFastResults",

  // ─── Insurance pitch (shared) ───
  insurancePitchHeading: "insurancePitchHeading",
  insurancePitchBody: "insurancePitchBody",
  insurancePitchCta1: "insurancePitchCta1",
  insurancePitchCta2: "insurancePitchCta2",

  // ─── Couples discount (fullbodymri) ───
  couplesHeading: "couplesHeading",
  couplesBody: "couplesBody",
  couplesBullet1: "couplesBullet1",
  couplesBullet2: "couplesBullet2",
  couplesBullet3: "couplesBullet3",
  couplesCta: "couplesCta",

  // ─── Process/How it works (shared) ───
  processHeading: "processHeading",
  processBody: "processBody",
  processStep1Title: "processStep1Title",
  processStep1Desc: "processStep1Desc",
  processStep2Title: "processStep2Title",
  processStep2Desc: "processStep2Desc",
  bloodProcessStep3Title: "bloodProcessStep3Title",
  mriProcessStep3Title: "mriProcessStep3Title",
  bloodProcessStep3Desc: "bloodProcessStep3Desc",
  mriProcessStep3Desc: "mriProcessStep3Desc",
  processStep4Title: "processStep4Title",
  processStep4Desc: "processStep4Desc",

  // ─── Report preview (shared) ───
  reportLabel: "reportLabel",
  reportHeading: "reportHeading",
  reportBody: "reportBody",
  reportCta1: "reportCta1",
  reportCta2: "reportCta2",
  // ─── Testimonials eyebrow + view-all (membership) ───
  testimonialsLabel: "testimonialsLabel",
  testimonialsViewAll: "testimonialsViewAll",

  // ─── Diseases section (checkup) ───
  diseasesHeading: "diseasesHeading",
  diseasesBody: "diseasesBody",
  seeAllConditions: "seeAllConditions",
  /* Risk-reversal line under the primary CTAs. Shared by every /go concern LP. */
  ctaReassurance: "ctaReassurance",

  // ─── Package selector (shared) ───
  packageSelectorHeading: "packageSelectorHeading",
  packageSelectorBody: "packageSelectorBody",
  packageBloodEyebrow: "packageBloodEyebrow",
  packageBloodTitle: "packageBloodTitle",
  packageBloodDesc: "packageBloodDesc",
  packageBloodForLabel: "packageBloodForLabel",
  packageBloodFor1: "packageBloodFor1",
  packageBloodFor2: "packageBloodFor2",
  packageBloodFor3: "packageBloodFor3",
  packageBloodFrom: "packageBloodFrom",
  packageBloodPrice: "packageBloodPrice",
  packageBloodCta: "packageBloodCta",
  packageMriEyebrow: "packageMriEyebrow",
  packageMriTitle: "packageMriTitle",
  packageMriDesc: "packageMriDesc",
  packageMriForLabel: "packageMriForLabel",
  packageMriFor1: "packageMriFor1",
  packageMriFor2: "packageMriFor2",
  packageMriFor3: "packageMriFor3",
  packageMriFrom: "packageMriFrom",
  packageMriPrice: "packageMriPrice",
  packageMriCta: "packageMriCta",
  packageCompare: "packageCompare",

  // ─── Experts section (go/ pages) ───
  expertsEyebrow: "expertsEyebrow",
  expertsHeading: "goExpertsHeading",
  expertsSub: "goExpertsSub",

  // ─── Experts section, "developed with" framing (go/bloodtest, DE only) ───
  // Same six faces, different claim: these advisors and medical founding
  // partners shaped the check-up rather than reading your report. Kept as its
  // own key set because the three above are shared with every other /go page,
  // the German city LPs and /reviews.
  bloodtestAdvisorsEyebrow: "bloodtestAdvisorsEyebrow",
  bloodtestAdvisorsHeading: "bloodtestAdvisorsHeading",
  bloodtestAdvisorsSub: "bloodtestAdvisorsSub",

  // ─── CTA sections ───
  ctaHeading: "ctaHeading",
  ctaBody: "ctaBody",
  ctaCta1: "ctaCta1",
  ctaCta2: "ctaCta2",

  // ─── /go/bloodtest ───
  bloodtestHeroHeading: "bloodtestHeroHeading",
  bloodtestHeroBody: "bloodtestHeroBody",
  bloodtestHeroLocation: "bloodtestHeroLocation",
  bloodtestHeroStatLocations: "bloodtestHeroStatLocations",
  bloodtestHeroCta1: "bloodtestHeroCta1",
  bloodtestHeroCta2: "bloodtestHeroCta2",
  bloodtestBiomarkersCta: "bloodtestBiomarkersCta",
  bloodtestPricingHeading: "bloodtestPricingHeading",
  bloodtestPricingBody: "bloodtestPricingBody",
  // CH-only (rendered only where MRI is bookable): recaptures blood intent
  // towards the full-body MRI check-ups.
  bloodtestMriFaqQ: "bloodtestMriFaqQ",
  bloodtestMriFaqIntro: "bloodtestMriFaqIntro",
  bloodtestMriFaqWhen: "bloodtestMriFaqWhen",
  bloodtestMriFaqWhen1: "bloodtestMriFaqWhen1",
  bloodtestMriFaqWhen2: "bloodtestMriFaqWhen2",
  bloodtestMriFaqAdvanced: "bloodtestMriFaqAdvanced",
  bloodtestMriFaqLink: "bloodtestMriFaqLink",
  // Page-owned copy for the shared <BloodTestCard>: desc and feature 1 name the
  // biomarker count, which this LP advertises per market. Features 2 to 6 and
  // AddTests are the DE ad LPs' own "includes" list and trust label
  // (/go/bloodtest, -berlin, -munich); other catalogs mirror the shared card.
  bloodtestCardDesc: "bloodtestCardDesc",
  bloodtestCardFeature1: "bloodtestCardFeature1",
  bloodtestCardFeature2: "bloodtestCardFeature2",
  bloodtestCardFeature3: "bloodtestCardFeature3",
  bloodtestCardFeature4: "bloodtestCardFeature4",
  bloodtestCardFeature5: "bloodtestCardFeature5",
  bloodtestCardFeature6: "bloodtestCardFeature6",
  bloodtestCardAddTests: "bloodtestCardAddTests",
  bloodtestAddonsHeading: "bloodtestAddonsHeading",
  bloodtestAddonsBody: "bloodtestAddonsBody",
  bloodtestAddonsMemberSuffix: "bloodtestAddonsMemberSuffix",
  // Membership vs one-off comparison cards (AHD-6470)
  bloodtestCompareSubtitle: "bloodtestCompareSubtitle",
  bloodtestCompareRecommended: "bloodtestCompareRecommended",
  bloodtestCompareMriDiscount: "bloodtestCompareMriDiscount",
  bloodtestCompareMembershipTitle: "bloodtestCompareMembershipTitle",
  bloodtestCompareMembershipDesc: "bloodtestCompareMembershipDesc",
  bloodtestCompareStartingAt: "bloodtestCompareStartingAt",
  bloodtestComparePerMonth: "bloodtestComparePerMonth",
  bloodtestCompareChargedAnnually: "bloodtestCompareChargedAnnually",
  bloodtestCompareMembershipCta: "bloodtestCompareMembershipCta",
  bloodtestCompareBenefitAdvancedTest: "bloodtestCompareBenefitAdvancedTest",
  bloodtestCompareBenefitReport: "bloodtestCompareBenefitReport",
  bloodtestCompareBenefitFourTests: "bloodtestCompareBenefitFourTests",
  bloodtestCompareBenefitMriDiscount: "bloodtestCompareBenefitMriDiscount",
  bloodtestCompareBenefitAddonPricing: "bloodtestCompareBenefitAddonPricing",
  bloodtestCompareBenefitPrevention: "bloodtestCompareBenefitPrevention",
  bloodtestCompareBenefitFollowup: "bloodtestCompareBenefitFollowup",
  bloodtestCompareBenefitUpload: "bloodtestCompareBenefitUpload",
  bloodtestCompareBaselineBadge: "bloodtestCompareBaselineBadge",
  bloodtestCompareBaselineTitle: "bloodtestCompareBaselineTitle",
  bloodtestCompareBaselineTagline: "bloodtestCompareBaselineTagline",
  bloodtestCompareOneTime: "bloodtestCompareOneTime",
  bloodtestCompareBaselineCta: "bloodtestCompareBaselineCta",

  // ─── /go/fullbodymri ───
  fullbodymriHeroHeading: "fullbodymriHeroHeading",
  fullbodymriHeroBody: "fullbodymriHeroBody",
  fullbodymriHeroLocation: "fullbodymriHeroLocation",
  fullbodymriHeroCta1: "fullbodymriHeroCta1",
  fullbodymriHeroCta2: "fullbodymriHeroCta2",
  fullbodymriPricingHeading: "fullbodymriPricingHeading",
  fullbodymriPricingBody: "fullbodymriPricingBody",
  fullbodymriHealthHeading: "fullbodymriHealthHeading",
  fullbodymriHealthBody: "fullbodymriHealthBody",

  // ─── /go/checkup ───
  checkupHeroHeading: "checkupHeroHeading",
  checkupHeroBody: "checkupHeroBody",
  checkupHeroLocation: "checkupHeroLocation",
  checkupHeroCta1: "checkupHeroCta1",
  checkupHeroCta2: "checkupHeroCta2",
  checkupHealthHeading: "checkupHealthHeading",
  checkupHealthBody: "checkupHealthBody",

  // ─── /go/checkup (was checkup-2, now the default) ───
  checkup2HeroHeading: "checkup2HeroHeading",
  checkup2HeroBody: "checkup2HeroBody",
  checkup2HeroLocation: "checkup2HeroLocation",
  checkup2HeroCta1: "checkup2HeroCta1",
  checkup2HeroCta2: "checkup2HeroCta2",
  checkup2TestsHeading: "checkup2TestsHeading",
  checkup2TestsBody: "checkup2TestsBody",

  // ─── /go/insurance* process steps ───
  insuranceProcessHeading: "insuranceProcessHeading",
  insuranceProcessStep1Title: "insuranceProcessStep1Title",
  insuranceProcessStep1Desc: "insuranceProcessStep1Desc",
  insuranceProcessStep2Title: "insuranceProcessStep2Title",
  insuranceProcessStep2Desc: "insuranceProcessStep2Desc",
  insuranceProcessStep3Title: "insuranceProcessStep3Title",
  insuranceProcessStep3Desc: "insuranceProcessStep3Desc",
  insuranceProcessStep4Title: "insuranceProcessStep4Title",
  insuranceProcessStep4Desc: "insuranceProcessStep4Desc",

  // ─── /go/insurancemri ───
  insurancemriHeroHeading: "insurancemriHeroHeading",
  insurancemriHeroBody: "insurancemriHeroBody",
  insurancemriHeroCta: "insurancemriHeroCta",
  insurancemriPricingHeading: "insurancemriPricingHeading",
  insurancemriPricingDescription: "insurancemriPricingDescription",
  insurancemriTestsHeading: "insurancemriTestsHeading",
  insurancemriTestsBody: "insurancemriTestsBody",
  insurancemriArticlesHeading: "insurancemriArticlesHeading",
  insurancemriArticle1: "insurancemriArticle1",
  insurancemriArticle2: "insurancemriArticle2",
  insurancemriArticle3: "insurancemriArticle3",
  readMore: "readMore",

  // ─── /go/insuranceblood ───
  insurancebloodHeroHeading: "insurancebloodHeroHeading",
  insurancebloodHeroBody: "insurancebloodHeroBody",
  insurancebloodHeroCta: "insurancebloodHeroCta",
  insurancebloodTestsHeading: "insurancebloodTestsHeading",
  insurancebloodTestsBody: "insurancebloodTestsBody",

  // ─── /go/membership ───
  membershipHeroPill: "membershipHeroPill",
  membershipHeroHeading: "membershipHeroHeading",
  membershipHeroBody: "membershipHeroBody",
  membershipHeroLocation: "membershipHeroLocation",
  membershipHeroCta1: "membershipHeroCta1",
  membershipHeroCta2: "membershipHeroCta2",
  membershipHeroFromLabel: "membershipHeroFromLabel",
  membershipHeroTrustReviewed: "membershipHeroTrustReviewed",
  membershipHeroTrustPlan: "membershipHeroTrustPlan",
  trustMembershipMonitoring: "trustMembershipMonitoring",
  trustMembershipExperts: "trustMembershipExperts",
  trustMembershipSavings: "trustMembershipSavings",
  trustMembershipPlan: "trustMembershipPlan",

  // ─── Organic (indexable) sibling meta titles ───
  // The clean `/heart-health`, `/metabolism`, `/female-hormones` pages use
  // these instead of the campaign-tuned /go metaTitle keys: head-term-first
  // and length-tightened for organic SERP snippets, so the ad LPs keep their
  // own titles. The brand suffix is appended in-page via `title.absolute`, so
  // these values carry no "| Ahead Health". Descriptions stay shared with the
  // /go keys (already optimized). Non-EN drafts pending review-cockpit sign-off.
  heartHealthOrganicMetaTitle: "heartHealthOrganicMetaTitle",
  metabolismOrganicMetaTitle: "metabolismOrganicMetaTitle",
  femaleHormonesOrganicMetaTitle: "femaleHormonesOrganicMetaTitle",

  // ─── /go/female-hormones ───
  femaleHormonesMetaTitle: "femaleHormonesMetaTitle",
  femaleHormonesMetaDescription: "femaleHormonesMetaDescription",
  femaleHormonesHeroEyebrow: "femaleHormonesHeroEyebrow",
  femaleHormonesHeroHeading: "femaleHormonesHeroHeading",
  femaleHormonesHeroBody: "femaleHormonesHeroBody",
  femaleHormonesHeroCta1: "femaleHormonesHeroCta1",
  femaleHormonesHeroCta2: "femaleHormonesHeroCta2",
  femaleHormonesHeroIndirectCta: "femaleHormonesHeroIndirectCta",
  femaleHormonesTrust1: "femaleHormonesTrust1",
  femaleHormonesTrust2: "femaleHormonesTrust2",
  femaleHormonesTrust3: "femaleHormonesTrust3",
  femaleHormonesTrust4: "femaleHormonesTrust4",
  femaleHormonesHeroKpi1Value: "femaleHormonesHeroKpi1Value",
  femaleHormonesHeroKpi1Label: "femaleHormonesHeroKpi1Label",
  femaleHormonesHeroKpi2Value: "femaleHormonesHeroKpi2Value",
  femaleHormonesHeroKpi2Label: "femaleHormonesHeroKpi2Label",
  femaleHormonesHeroKpi3Value: "femaleHormonesHeroKpi3Value",
  femaleHormonesHeroKpi3Label: "femaleHormonesHeroKpi3Label",
  femaleHormonesSignsEyebrow: "femaleHormonesSignsEyebrow",
  femaleHormonesSignsHeading: "femaleHormonesSignsHeading",
  femaleHormonesSignsBody: "femaleHormonesSignsBody",
  femaleHormonesSign1Title: "femaleHormonesSign1Title",
  femaleHormonesSign1Desc: "femaleHormonesSign1Desc",
  femaleHormonesSign2Title: "femaleHormonesSign2Title",
  femaleHormonesSign2Desc: "femaleHormonesSign2Desc",
  femaleHormonesSign3Title: "femaleHormonesSign3Title",
  femaleHormonesSign3Desc: "femaleHormonesSign3Desc",
  femaleHormonesSign4Title: "femaleHormonesSign4Title",
  femaleHormonesSign4Desc: "femaleHormonesSign4Desc",
  femaleHormonesSign5Title: "femaleHormonesSign5Title",
  femaleHormonesSign5Desc: "femaleHormonesSign5Desc",
  femaleHormonesSign6Title: "femaleHormonesSign6Title",
  femaleHormonesSign6Desc: "femaleHormonesSign6Desc",
  femaleHormonesMeasureEyebrow: "femaleHormonesMeasureEyebrow",
  femaleHormonesMeasureHeading: "femaleHormonesMeasureHeading",
  femaleHormonesMeasureBody: "femaleHormonesMeasureBody",
  femaleHormonesMeasureG1Title: "femaleHormonesMeasureG1Title",
  femaleHormonesMeasureG1Count: "femaleHormonesMeasureG1Count",
  femaleHormonesMeasureG1Markers: "femaleHormonesMeasureG1Markers",
  femaleHormonesMeasureG1Body: "femaleHormonesMeasureG1Body",
  femaleHormonesMeasureG2Title: "femaleHormonesMeasureG2Title",
  femaleHormonesMeasureG2Count: "femaleHormonesMeasureG2Count",
  femaleHormonesMeasureG2Markers: "femaleHormonesMeasureG2Markers",
  femaleHormonesMeasureG2Body: "femaleHormonesMeasureG2Body",
  femaleHormonesMeasureG3Title: "femaleHormonesMeasureG3Title",
  femaleHormonesMeasureG3Count: "femaleHormonesMeasureG3Count",
  femaleHormonesMeasureG3Markers: "femaleHormonesMeasureG3Markers",
  femaleHormonesMeasureG3Body: "femaleHormonesMeasureG3Body",
  femaleHormonesMeasureG4Title: "femaleHormonesMeasureG4Title",
  femaleHormonesMeasureG4Count: "femaleHormonesMeasureG4Count",
  femaleHormonesMeasureG4Markers: "femaleHormonesMeasureG4Markers",
  femaleHormonesMeasureG4Body: "femaleHormonesMeasureG4Body",
  femaleHormonesWmTagAddon: "femaleHormonesWmTagAddon",
  femaleHormonesWmTagBase: "femaleHormonesWmTagBase",
  femaleHormonesMeasureBridge: "femaleHormonesMeasureBridge",
  femaleHormonesCoverageEyebrow: "femaleHormonesCoverageEyebrow",
  femaleHormonesCoverageHeading: "femaleHormonesCoverageHeading",
  femaleHormonesCoverageBody: "femaleHormonesCoverageBody",
  femaleHormonesProcessHeading: "femaleHormonesProcessHeading",
  femaleHormonesProcessBody: "femaleHormonesProcessBody",
  femaleHormonesProcessStep1Title: "femaleHormonesProcessStep1Title",
  femaleHormonesProcessStep1Desc: "femaleHormonesProcessStep1Desc",
  femaleHormonesProcessStep2Title: "femaleHormonesProcessStep2Title",
  femaleHormonesProcessStep2Desc: "femaleHormonesProcessStep2Desc",
  femaleHormonesProcessStep3Title: "femaleHormonesProcessStep3Title",
  femaleHormonesProcessStep3Desc: "femaleHormonesProcessStep3Desc",
  femaleHormonesProcessStep4Title: "femaleHormonesProcessStep4Title",
  femaleHormonesProcessStep4Desc: "femaleHormonesProcessStep4Desc",
  femaleHormonesStatsEyebrow: "femaleHormonesStatsEyebrow",
  femaleHormonesStat1Value: "femaleHormonesStat1Value",
  femaleHormonesStat1Label: "femaleHormonesStat1Label",
  femaleHormonesStat2Value: "femaleHormonesStat2Value",
  femaleHormonesStat2Label: "femaleHormonesStat2Label",
  femaleHormonesStat3Value: "femaleHormonesStat3Value",
  femaleHormonesStat3Label: "femaleHormonesStat3Label",
  femaleHormonesStat4Value: "femaleHormonesStat4Value",
  femaleHormonesStat4Label: "femaleHormonesStat4Label",
  femaleHormonesOfferEyebrow: "femaleHormonesOfferEyebrow",
  femaleHormonesOfferHeading: "femaleHormonesOfferHeading",
  femaleHormonesOfferBody: "femaleHormonesOfferBody",
  femaleHormonesOfferCard1Label: "femaleHormonesOfferCard1Label",
  femaleHormonesOfferCard1Unit: "femaleHormonesOfferCard1Unit",
  femaleHormonesOfferCard1Item1: "femaleHormonesOfferCard1Item1",
  femaleHormonesOfferCard1Item2: "femaleHormonesOfferCard1Item2",
  femaleHormonesOfferCard1Item3: "femaleHormonesOfferCard1Item3",
  femaleHormonesOfferCard1Item4: "femaleHormonesOfferCard1Item4",
  femaleHormonesOfferCard2Badge: "femaleHormonesOfferCard2Badge",
  femaleHormonesOfferCard2Label: "femaleHormonesOfferCard2Label",
  femaleHormonesOfferCard2Unit: "femaleHormonesOfferCard2Unit",
  femaleHormonesOfferCard2Item1: "femaleHormonesOfferCard2Item1",
  femaleHormonesOfferCard2Item2: "femaleHormonesOfferCard2Item2",
  femaleHormonesOfferCard2Item3: "femaleHormonesOfferCard2Item3",
  femaleHormonesOfferCard2Item4: "femaleHormonesOfferCard2Item4",
  femaleHormonesOfferCard3Label: "femaleHormonesOfferCard3Label",
  femaleHormonesOfferCard3Unit: "femaleHormonesOfferCard3Unit",
  femaleHormonesOfferCard3Item1: "femaleHormonesOfferCard3Item1",
  femaleHormonesOfferCard3Item2: "femaleHormonesOfferCard3Item2",
  femaleHormonesOfferCard3Item3: "femaleHormonesOfferCard3Item3",
  femaleHormonesOfferCard3Cta: "femaleHormonesOfferCard3Cta",
  femaleHormonesOfferFootnote: "femaleHormonesOfferFootnote",
  femaleHormonesAdvisoryEyebrow: "femaleHormonesAdvisoryEyebrow",
  femaleHormonesAdvisoryHeading: "femaleHormonesAdvisoryHeading",
  femaleHormonesAdvisorySub: "femaleHormonesAdvisorySub",
  femaleHormonesFaqHeading: "femaleHormonesFaqHeading",
  femaleHormonesFaqQ1: "femaleHormonesFaqQ1",
  femaleHormonesFaqA1: "femaleHormonesFaqA1",
  femaleHormonesFaqQ2: "femaleHormonesFaqQ2",
  femaleHormonesFaqA2: "femaleHormonesFaqA2",
  femaleHormonesFaqQ3: "femaleHormonesFaqQ3",
  femaleHormonesFaqA3: "femaleHormonesFaqA3",
  femaleHormonesFaqQ4: "femaleHormonesFaqQ4",
  femaleHormonesFaqA4: "femaleHormonesFaqA4",
  femaleHormonesFaqQ5: "femaleHormonesFaqQ5",
  femaleHormonesFaqA5: "femaleHormonesFaqA5",
  femaleHormonesFaqQ6: "femaleHormonesFaqQ6",
  femaleHormonesFaqA6: "femaleHormonesFaqA6",
  femaleHormonesCtaHeading: "femaleHormonesCtaHeading",
  femaleHormonesCtaBody: "femaleHormonesCtaBody",
  femaleHormonesCtaCta1: "femaleHormonesCtaCta1",
  femaleHormonesCtaCta2: "femaleHormonesCtaCta2",
  femaleHormonesHeroReviewLabel: "femaleHormonesHeroReviewLabel",
  femaleHormonesWedgeHeading1: "femaleHormonesWedgeHeading1",
  femaleHormonesWedgeHeading2: "femaleHormonesWedgeHeading2",
  femaleHormonesRevealHeading: "femaleHormonesRevealHeading",
  femaleHormonesRevealSubhead: "femaleHormonesRevealSubhead",
  femaleHormonesReveal1Title: "femaleHormonesReveal1Title",
  femaleHormonesReveal1Body: "femaleHormonesReveal1Body",
  femaleHormonesReveal1Verdict: "femaleHormonesReveal1Verdict",
  femaleHormonesReveal2Title: "femaleHormonesReveal2Title",
  femaleHormonesReveal2Body: "femaleHormonesReveal2Body",
  femaleHormonesReveal2Verdict: "femaleHormonesReveal2Verdict",
  femaleHormonesReveal3Title: "femaleHormonesReveal3Title",
  femaleHormonesReveal3Body: "femaleHormonesReveal3Body",
  femaleHormonesReveal3Verdict: "femaleHormonesReveal3Verdict",
  femaleHormonesReveal4Title: "femaleHormonesReveal4Title",
  femaleHormonesReveal4Body: "femaleHormonesReveal4Body",
  femaleHormonesReveal4Verdict: "femaleHormonesReveal4Verdict",
  femaleHormonesRevealCombinedLabel: "femaleHormonesRevealCombinedLabel",
  femaleHormonesRevealNormalLabel: "femaleHormonesRevealNormalLabel",
  femaleHormonesRevealStructureLabel: "femaleHormonesRevealStructureLabel",
  femaleHormonesRevealPin1: "femaleHormonesRevealPin1",
  femaleHormonesRevealPin2: "femaleHormonesRevealPin2",
  femaleHormonesRevealPin3: "femaleHormonesRevealPin3",
  femaleHormonesRevealPause: "femaleHormonesRevealPause",
  femaleHormonesRevealPlay: "femaleHormonesRevealPlay",
  femaleHormonesBadgeNormal: "femaleHormonesBadgeNormal",
  femaleHormonesBadgeLow: "femaleHormonesBadgeLow",
  femaleHormonesBadgeHighNormal: "femaleHormonesBadgeHighNormal",
  femaleHormonesMkTestosterone: "femaleHormonesMkTestosterone",
  femaleHormonesMkShbg: "femaleHormonesMkShbg",
  femaleHormonesMkProgesterone: "femaleHormonesMkProgesterone",
  femaleHormonesMkEstradiol: "femaleHormonesMkEstradiol",
  femaleHormonesMkFsh: "femaleHormonesMkFsh",
  femaleHormonesMkLh: "femaleHormonesMkLh",
  femaleHormonesMriEyebrow: "femaleHormonesMriEyebrow",
  femaleHormonesMriHeading: "femaleHormonesMriHeading",
  femaleHormonesMriBody: "femaleHormonesMriBody",
  femaleHormonesMriCta: "femaleHormonesMriCta",
  femaleHormonesMriFinding1Title: "femaleHormonesMriFinding1Title",
  femaleHormonesMriFinding1Note: "femaleHormonesMriFinding1Note",
  femaleHormonesMriFinding2Title: "femaleHormonesMriFinding2Title",
  femaleHormonesMriFinding2Note: "femaleHormonesMriFinding2Note",
  femaleHormonesMriFinding3Title: "femaleHormonesMriFinding3Title",
  femaleHormonesMriFinding3Note: "femaleHormonesMriFinding3Note",
  femaleHormonesMriBadgeObservation: "femaleHormonesMriBadgeObservation",
  femaleHormonesMriBadgeMinor: "femaleHormonesMriBadgeMinor",
  femaleHormonesMriIllustrative: "femaleHormonesMriIllustrative",
  femaleHormonesProcessLabel: "femaleHormonesProcessLabel",
  femaleHormonesProcessStepWord: "femaleHormonesProcessStepWord",
  femaleHormonesReportEyebrow: "femaleHormonesReportEyebrow",
  femaleHormonesReportHeading: "femaleHormonesReportHeading",
  femaleHormonesReportBody: "femaleHormonesReportBody",
  femaleHormonesReportCta: "femaleHormonesReportCta",
  femaleHormonesGpHeading: "femaleHormonesGpHeading",
  femaleHormonesGpBody: "femaleHormonesGpBody",
  femaleHormonesGpAheadTitle: "femaleHormonesGpAheadTitle",
  femaleHormonesGpAheadRow1: "femaleHormonesGpAheadRow1",
  femaleHormonesGpAheadRow2: "femaleHormonesGpAheadRow2",
  femaleHormonesGpAheadRow3: "femaleHormonesGpAheadRow3",
  femaleHormonesGpAheadRow4: "femaleHormonesGpAheadRow4",
  femaleHormonesGpAheadRow5: "femaleHormonesGpAheadRow5",
  femaleHormonesGpAheadRow6: "femaleHormonesGpAheadRow6",
  femaleHormonesGpAheadRow7: "femaleHormonesGpAheadRow7",
  femaleHormonesGpTypicalTitle: "femaleHormonesGpTypicalTitle",
  femaleHormonesGpTypicalRow1: "femaleHormonesGpTypicalRow1",
  femaleHormonesGpTypicalRow2: "femaleHormonesGpTypicalRow2",
  femaleHormonesGpTypicalRow3: "femaleHormonesGpTypicalRow3",
  femaleHormonesGpTypicalRow4: "femaleHormonesGpTypicalRow4",
  femaleHormonesGpTypicalRow5: "femaleHormonesGpTypicalRow5",
  femaleHormonesGpTypicalRow6: "femaleHormonesGpTypicalRow6",
  femaleHormonesGpTypicalRow7: "femaleHormonesGpTypicalRow7",
  femaleHormonesPricingAddonRow: "femaleHormonesPricingAddonRow",
  femaleHormonesPricingBaselineNote: "femaleHormonesPricingBaselineNote",
  femaleHormonesPricingMriPriceFrom: "femaleHormonesPricingMriPriceFrom",
  femaleHormonesPricingMriPrice: "femaleHormonesPricingMriPrice",
  femaleHormonesPricingMriRow1: "femaleHormonesPricingMriRow1",
  femaleHormonesPricingMriRow2: "femaleHormonesPricingMriRow2",
  femaleHormonesPricingMriRow3: "femaleHormonesPricingMriRow3",
  femaleHormonesPricingMriCardTagline: "femaleHormonesPricingMriCardTagline",

  // ─── Laura Philipp athlete campaign LP (/go/lauraphilipps) ───
  // CH-only (page:go/lauraphilipps). Copy is final and approved; the
  // ambassador quote is verbatim and must not be edited. No performance or
  // health claim on the page is attributed to the athlete.
  athleteMetaTitle: "athleteMetaTitle",
  athleteMetaDescription: "athleteMetaDescription",
  // `*BloodOnly` twins: the lines that name the scan, rewritten for a market
  // that does not sell it. Chosen by the page's `showImaging` boolean — see
  // lauraphilipps/page.tsx. Not a fallback: both are authored copy.
  athleteMetaDescriptionBloodOnly: "athleteMetaDescriptionBloodOnly",
  athleteHeroEyebrow: "athleteHeroEyebrow",
  athleteHeroEyebrowBloodOnly: "athleteHeroEyebrowBloodOnly",
  athleteHeroHeading: "athleteHeroHeading",
  athleteHeroBody: "athleteHeroBody",
  athleteHeroBodyBloodOnly: "athleteHeroBodyBloodOnly",
  athleteHeroCta1: "athleteHeroCta1",
  /* Soft secondary CTA beside the hero's booking button, to the `/quiz-focus`
     funnel. Only rendered where that funnel exists — see `AthleteQuizCta`. */
  athleteQuizCta: "athleteQuizCta",
  athleteHeroPhotoAlt: "athleteHeroPhotoAlt",
  athleteHeroReviewLabel: "athleteHeroReviewLabel",
  athleteHeroKpi1Value: "athleteHeroKpi1Value",
  athleteHeroKpi1Label: "athleteHeroKpi1Label",
  athleteHeroKpi2Value: "athleteHeroKpi2Value",
  athleteHeroKpi2Label: "athleteHeroKpi2Label",
  athleteHeroKpi3Value: "athleteHeroKpi3Value",
  athleteHeroKpi3Label: "athleteHeroKpi3Label",
  athleteQuoteEyebrow: "athleteQuoteEyebrow",
  athleteQuote: "athleteQuote",
  athleteQuoteName: "athleteQuoteName",
  athleteQuoteRole: "athleteQuoteRole",
  athleteQuotePhotoAlt: "athleteQuotePhotoAlt",
  // The four steps are /dev/home-v3's "The practical part", copy and all.
  // One key per heading line: a blood-only market drops the scan line and
  // the scan step, keeps the other two, and closes on the follow-up test.
  athleteStepsEyebrow: "athleteStepsEyebrow",
  athleteStepsHeadingBlood: "athleteStepsHeadingBlood",
  athleteStepsHeadingScan: "athleteStepsHeadingScan",
  athleteStepsHeadingAccent: "athleteStepsHeadingAccent",
  athleteStep1Title: "athleteStep1Title",
  athleteStep1Body: "athleteStep1Body",
  athleteStep1ImageAlt: "athleteStep1ImageAlt",
  athleteStep2Title: "athleteStep2Title",
  athleteStep2Body: "athleteStep2Body",
  athleteStep2ImageAlt: "athleteStep2ImageAlt",
  athleteStep3Title: "athleteStep3Title",
  athleteStep3Body: "athleteStep3Body",
  athleteStep3ImageAlt: "athleteStep3ImageAlt",
  athleteStep4Title: "athleteStep4Title",
  athleteStep4Body: "athleteStep4Body",
  athleteStep4ImageAlt: "athleteStep4ImageAlt",
  athleteStepFollowUpTitle: "athleteStepFollowUpTitle",
  athleteStepFollowUpBody: "athleteStepFollowUpBody",
  athleteStepFollowUpImageAlt: "athleteStepFollowUpImageAlt",
  athleteWedgeHeading1: "athleteWedgeHeading1",
  athleteWedgeHeading2: "athleteWedgeHeading2",
  athleteSignalsSummaryBody: "athleteSignalsSummaryBody",
  athleteRevealEyebrow: "athleteRevealEyebrow",
  athleteRevealHeading: "athleteRevealHeading",
  athleteRevealBody: "athleteRevealBody",
  athleteRevealRow1: "athleteRevealRow1",
  athleteRevealRow2: "athleteRevealRow2",
  athleteRevealRow3: "athleteRevealRow3",
  athleteRevealRow4: "athleteRevealRow4",
  athleteRevealCta: "athleteRevealCta",
  athleteCoverageEyebrow: "athleteCoverageEyebrow",
  athleteCoverageHeading: "athleteCoverageHeading",
  athleteCoverageBody: "athleteCoverageBody",
  athleteCoverageBodyBloodOnly: "athleteCoverageBodyBloodOnly",
  athleteOfferEyebrow: "athleteOfferEyebrow",
  athleteOfferHeading: "athleteOfferHeading",
  athleteOfferHeadingBloodOnly: "athleteOfferHeadingBloodOnly",
  athleteOfferFootnote: "athleteOfferFootnote",
  athletePricingBaselineCta: "athletePricingBaselineCta",
  athletePricingSharedRow1: "athletePricingSharedRow1",
  athletePricingMriTagline: "athletePricingMriTagline",
  athletePricingMriRow1: "athletePricingMriRow1",
  athletePricingMriRow2: "athletePricingMriRow2",
  athletePricingMriRow3: "athletePricingMriRow3",
  athleteCtaHeading: "athleteCtaHeading",
  athleteCtaBody: "athleteCtaBody",
  athleteCtaBodyBloodOnly: "athleteCtaBodyBloodOnly",
  athleteHomepageCtaHeading: "athleteHomepageCtaHeading",
  athleteHomepageCtaBody: "athleteHomepageCtaBody",
  athleteCtaFinePrint: "athleteCtaFinePrint",

  immunityHeroEyebrow: "immunityHeroEyebrow",
  immunityHeroHeading: "immunityHeroHeading",
  immunityHeroBody: "immunityHeroBody",
  immunityHeroCta1: "immunityHeroCta1",
  immunityHeroKpi1Value: "immunityHeroKpi1Value",
  immunityHeroKpi1Label: "immunityHeroKpi1Label",
  immunityHeroKpi2Value: "immunityHeroKpi2Value",
  immunityHeroKpi2Label: "immunityHeroKpi2Label",
  immunityHeroKpi3Value: "immunityHeroKpi3Value",
  immunityHeroKpi3Label: "immunityHeroKpi3Label",
  immunityWedgeHeading1: "immunityWedgeHeading1",
  immunityWedgeHeading2: "immunityWedgeHeading2",
  immunityWedgeBody: "immunityWedgeBody",
  immunityCtaEyebrow: "immunityCtaEyebrow",
  immunitySignsEyebrow: "immunitySignsEyebrow",
  immunitySignsHeading: "immunitySignsHeading",
  immunitySignsBody: "immunitySignsBody",
  immunitySign1Title: "immunitySign1Title",
  immunitySign1Desc: "immunitySign1Desc",
  immunitySign2Title: "immunitySign2Title",
  immunitySign2Desc: "immunitySign2Desc",
  immunitySign3Title: "immunitySign3Title",
  immunitySign3Desc: "immunitySign3Desc",
  immunitySign4Title: "immunitySign4Title",
  immunitySign4Desc: "immunitySign4Desc",
  immunitySign5Title: "immunitySign5Title",
  immunitySign5Desc: "immunitySign5Desc",
  immunitySign6Title: "immunitySign6Title",
  immunitySign6Desc: "immunitySign6Desc",
  immunityMeasureEyebrow: "immunityMeasureEyebrow",
  immunityMeasureHeading: "immunityMeasureHeading",
  immunityMeasureBody: "immunityMeasureBody",
  immunityMarker1Eyebrow: "immunityMarker1Eyebrow",
  immunityMarker1Title: "immunityMarker1Title",
  immunityMarker1Desc: "immunityMarker1Desc",
  immunityMarker2Eyebrow: "immunityMarker2Eyebrow",
  immunityMarker2Title: "immunityMarker2Title",
  immunityMarker2Desc: "immunityMarker2Desc",
  immunityMarker3Eyebrow: "immunityMarker3Eyebrow",
  immunityMarker3Title: "immunityMarker3Title",
  immunityMarker3Desc: "immunityMarker3Desc",
  immunityMarker4Eyebrow: "immunityMarker4Eyebrow",
  immunityMarker4Title: "immunityMarker4Title",
  immunityMarker4Desc: "immunityMarker4Desc",
  immunityProcessHeading: "immunityProcessHeading",
  immunityProcessBody: "immunityProcessBody",
  immunityProcessStep1Title: "immunityProcessStep1Title",
  immunityProcessStep1Desc: "immunityProcessStep1Desc",
  immunityProcessStep2Title: "immunityProcessStep2Title",
  immunityProcessStep2Desc: "immunityProcessStep2Desc",
  immunityProcessStep3Title: "immunityProcessStep3Title",
  immunityProcessStep3Desc: "immunityProcessStep3Desc",
  immunityCtaHeading: "immunityCtaHeading",
  immunityCtaBody: "immunityCtaBody",
  immunityCtaCta1: "immunityCtaCta1",
  immunityCoverageEyebrow: "immunityCoverageEyebrow",
  immunityCoverageHeading: "immunityCoverageHeading",
  immunityCoverageBody: "immunityCoverageBody",
  // ─── Metabolism LP (EN-only prototype) — nested under go.metabolism.* ───
  metabolismHeroEyebrow: "metabolism.heroEyebrow",
  metabolismHeroHeading: "metabolism.heroHeading",
  metabolismHeroBody: "metabolism.heroBody",
  metabolismHeroCta1: "metabolism.heroCta1",
  metabolismHeroKpi1Value: "metabolism.heroKpi1Value",
  metabolismHeroKpi1Label: "metabolism.heroKpi1Label",
  metabolismHeroKpi2Value: "metabolism.heroKpi2Value",
  metabolismHeroKpi2Label: "metabolism.heroKpi2Label",
  metabolismHeroKpi3Value: "metabolism.heroKpi3Value",
  metabolismHeroKpi3Label: "metabolism.heroKpi3Label",
  metabolismWedgeHeading1: "metabolism.wedgeHeading1",
  metabolismWedgeHeading2: "metabolism.wedgeHeading2",
  metabolismWedgeBody: "metabolism.wedgeBody",
  metabolismCtaEyebrow: "metabolism.ctaEyebrow",
  metabolismSignsEyebrow: "metabolism.signsEyebrow",
  metabolismSignsHeading: "metabolism.signsHeading",
  metabolismSignsBody: "metabolism.signsBody",
  metabolismSign1Title: "metabolism.sign1Title",
  metabolismSign1Desc: "metabolism.sign1Desc",
  metabolismSign2Title: "metabolism.sign2Title",
  metabolismSign2Desc: "metabolism.sign2Desc",
  metabolismSign3Title: "metabolism.sign3Title",
  metabolismSign3Desc: "metabolism.sign3Desc",
  metabolismSign4Title: "metabolism.sign4Title",
  metabolismSign4Desc: "metabolism.sign4Desc",
  metabolismSign5Title: "metabolism.sign5Title",
  metabolismSign5Desc: "metabolism.sign5Desc",
  metabolismSign6Title: "metabolism.sign6Title",
  metabolismSign6Desc: "metabolism.sign6Desc",
  metabolismMeasureEyebrow: "metabolism.measureEyebrow",
  metabolismMeasureHeading: "metabolism.measureHeading",
  metabolismMeasureBody: "metabolism.measureBody",
  metabolismMarker1Eyebrow: "metabolism.marker1Eyebrow",
  metabolismMarker1Title: "metabolism.marker1Title",
  metabolismMarker1Desc: "metabolism.marker1Desc",
  metabolismMarker2Eyebrow: "metabolism.marker2Eyebrow",
  metabolismMarker2Title: "metabolism.marker2Title",
  metabolismMarker2Desc: "metabolism.marker2Desc",
  metabolismMarker3Eyebrow: "metabolism.marker3Eyebrow",
  metabolismMarker3Title: "metabolism.marker3Title",
  metabolismMarker3Desc: "metabolism.marker3Desc",
  metabolismMarker4Eyebrow: "metabolism.marker4Eyebrow",
  metabolismMarker4Title: "metabolism.marker4Title",
  metabolismMarker4Desc: "metabolism.marker4Desc",
  metabolismProcessHeading: "metabolism.processHeading",
  metabolismProcessBody: "metabolism.processBody",
  metabolismProcessStep1Title: "metabolism.processStep1Title",
  metabolismProcessStep1Desc: "metabolism.processStep1Desc",
  metabolismProcessStep2Title: "metabolism.processStep2Title",
  metabolismProcessStep2Desc: "metabolism.processStep2Desc",
  metabolismProcessStep3Title: "metabolism.processStep3Title",
  metabolismProcessStep3Desc: "metabolism.processStep3Desc",
  metabolismProcessStep4Title: "metabolism.processStep4Title",
  metabolismProcessStep4Desc: "metabolism.processStep4Desc",
  metabolismStat1Value: "metabolism.stat1Value",
  metabolismStat1Label: "metabolism.stat1Label",
  metabolismStat2Value: "metabolism.stat2Value",
  metabolismStat2Label: "metabolism.stat2Label",
  metabolismStat3Value: "metabolism.stat3Value",
  metabolismStat3Label: "metabolism.stat3Label",
  metabolismStat4Value: "metabolism.stat4Value",
  metabolismStat4Label: "metabolism.stat4Label",
  metabolismCtaHeading: "metabolism.ctaHeading",
  metabolismCtaBody: "metabolism.ctaBody",
  metabolismCtaCta1: "metabolism.ctaCta1",
  metabolismCoverageEyebrow: "metabolism.coverageEyebrow",
  metabolismCoverageHeading: "metabolism.coverageHeading",
  metabolismCoverageBody: "metabolism.coverageBody",
  metabolismMriEyebrow: "metabolism.mriEyebrow",
  metabolismMriHeading: "metabolism.mriHeading",
  metabolismMriBody: "metabolism.mriBody",
  // AHD-10317 — the imaging cards' captions + the section CTA. These rendered
  // as a hardcoded English array (MRI_NOTES) and an inline JSX label, so every
  // non-EN locale served English here. Each caption is a STANDALONE sentence:
  // the previous shape appended the note to the translated marker name, which
  // only parses in English (see the note in metabolism-immersive.tsx).
  metabolismMriCardNote1: "metabolism.mriCardNote1",
  metabolismMriCardNote2: "metabolism.mriCardNote2",
  metabolismMriCardNote3: "metabolism.mriCardNote3",
  metabolismMriSectionCta: "metabolism.mriSectionCta",
  // AHD-8117 — strings that shipped hardcoded English when the LP went multilang
  metabolismMetaTitle: "metabolism.metaTitle",
  metabolismMetaDescription: "metabolism.metaDescription",
  metabolismHeroReviewLabel: "metabolism.heroReviewLabel",
  metabolismCoverageCta: "metabolism.coverageCta",
  metabolismProcessLabel: "metabolism.processLabel",
  metabolismProcessStepWord: "metabolism.processStepWord",
  metabolismProcessNoReferral: "metabolism.processNoReferral",
  metabolismReportEyebrow: "metabolism.reportEyebrow",
  metabolismReportHeading: "metabolism.reportHeading",
  metabolismReportBody: "metabolism.reportBody",
  metabolismReportCta: "metabolism.reportCta",
  metabolismPricingHeading: "metabolism.pricingHeading",
  metabolismPricingBody: "metabolism.pricingBody",
  metabolismPricingMriPriceFrom: "metabolism.pricingMriPriceFrom",
  metabolismPricingMriPrice: "metabolism.pricingMriPrice",
  metabolismPricingMriRow1: "metabolism.pricingMriRow1",
  metabolismPricingMriRow2: "metabolism.pricingMriRow2",
  metabolismPricingMriRow3: "metabolism.pricingMriRow3",
  metabolismPricingMriRow4: "metabolism.pricingMriRow4",
  metabolismPricingFootnote: "metabolism.pricingFootnote",
  metabolismPricingMriCardBadge: "metabolism.pricingMriCardBadge",
  metabolismPricingMriCardTitle: "metabolism.pricingMriCardTitle",
  metabolismPricingMriCardTagline: "metabolism.pricingMriCardTagline",
  metabolismPricingMriCardPriceLabel: "metabolism.pricingMriCardPriceLabel",
  metabolismPricingMriCardCta: "metabolism.pricingMriCardCta",
  // Immersive full-picture section — heading/subhead + card labels
  metabolismImmHeading: "metabolism.immHeading",
  metabolismImmSubhead: "metabolism.immSubhead",
  metabolismImmReadTogether: "metabolism.immReadTogether",
  metabolismImmMarkersBehind: "metabolism.immMarkersBehind",
  metabolismImmPause: "metabolism.immPause",
  metabolismImmPlay: "metabolism.immPlay",
  // Immersive cross-marker stories (4)
  metabolismStory1Title: "metabolism.story1Title",
  metabolismStory1Lead: "metabolism.story1Lead",
  metabolismStory1Body: "metabolism.story1Body",
  metabolismStory2Title: "metabolism.story2Title",
  metabolismStory2Lead: "metabolism.story2Lead",
  metabolismStory2Body: "metabolism.story2Body",
  metabolismStory3Title: "metabolism.story3Title",
  metabolismStory3Lead: "metabolism.story3Lead",
  metabolismStory3Body: "metabolism.story3Body",
  metabolismStory4Title: "metabolism.story4Title",
  metabolismStory4Lead: "metabolism.story4Lead",
  metabolismStory4Body: "metabolism.story4Body",
  // Marker names (deduped — reused across stories)
  metabolismMkFastingGlucose: "metabolism.mkFastingGlucose",
  metabolismMkHba1c: "metabolism.mkHba1c",
  metabolismMkHomaIr: "metabolism.mkHomaIr",
  metabolismMkTriglycerides: "metabolism.mkTriglycerides",
  metabolismMkHdl: "metabolism.mkHdl",
  metabolismMkTsh: "metabolism.mkTsh",
  metabolismMkFt4: "metabolism.mkFt4",
  metabolismMkAlt: "metabolism.mkAlt",
  metabolismMkGgt: "metabolism.mkGgt",
  metabolismMkVisceralFat: "metabolism.mkVisceralFat",
  metabolismMkLiverFat: "metabolism.mkLiverFat",
  metabolismMkMuscle: "metabolism.mkMuscle",
  // Group tags (deduped)
  metabolismGroupBloodSugar: "metabolism.groupBloodSugar",
  metabolismGroupLipids: "metabolism.groupLipids",
  metabolismGroupThyroid: "metabolism.groupThyroid",
  metabolismGroupLiver: "metabolism.groupLiver",
  metabolismGroupImaging: "metabolism.groupImaging",
  // Status badges (deduped)
  metabolismBadgeNormal: "metabolism.badgeNormal",
  metabolismBadgeIntermediate: "metabolism.badgeIntermediate",
  metabolismBadgeRaised: "metabolism.badgeRaised",
  metabolismBadgeHigh: "metabolism.badgeHigh",
  metabolismBadgeLow: "metabolism.badgeLow",
  metabolismBadgeLowNormal: "metabolism.badgeLowNormal",
  metabolismBadgeElevated: "metabolism.badgeElevated",
  // Marker-card chips (screens-for)
  metabolismMarker1Chip1: "metabolism.marker1Chip1",
  metabolismMarker1Chip2: "metabolism.marker1Chip2",
  metabolismMarker2Chip1: "metabolism.marker2Chip1",
  metabolismMarker2Chip2: "metabolism.marker2Chip2",
  metabolismMarker3Chip1: "metabolism.marker3Chip1",
  metabolismMarker3Chip2: "metabolism.marker3Chip2",
  metabolismMarker4Chip1: "metabolism.marker4Chip1",
  metabolismMarker4Chip2: "metabolism.marker4Chip2",
  // "Why not just my GP?" — what-you-get-back comparison (Ahead vs typical GP)
  metabolismGpHeading: "metabolism.gpHeading",
  metabolismGpBody: "metabolism.gpBody",
  metabolismGpAheadTitle: "metabolism.gpAheadTitle",
  metabolismGpAheadRow1: "metabolism.gpAheadRow1",
  metabolismGpAheadRow2: "metabolism.gpAheadRow2",
  metabolismGpAheadRow3: "metabolism.gpAheadRow3",
  metabolismGpAheadRow4: "metabolism.gpAheadRow4",
  metabolismGpAheadRow5: "metabolism.gpAheadRow5",
  metabolismGpAheadRow6: "metabolism.gpAheadRow6",
  metabolismGpTypicalTitle: "metabolism.gpTypicalTitle",
  metabolismGpTypicalRow1: "metabolism.gpTypicalRow1",
  metabolismGpTypicalRow2: "metabolism.gpTypicalRow2",
  metabolismGpTypicalRow3: "metabolism.gpTypicalRow3",
  metabolismGpTypicalRow4: "metabolism.gpTypicalRow4",
  metabolismGpTypicalRow5: "metabolism.gpTypicalRow5",
  metabolismGpTypicalRow6: "metabolism.gpTypicalRow6",
  // Pricing — baseline (blood) card CTA
  metabolismPricingBaselineCta: "metabolism.pricingBaselineCta",
  // Immersive full-picture section (i18n'd for multilang)
  immunityImmHeading: "immunityImmHeading",
  immunityImmSubhead: "immunityImmSubhead",
  immunityImmReadTogether: "immunityImmReadTogether",
  immunityImmMarkersLabel: "immunityImmMarkersLabel",
  immunityImmPause: "immunityImmPause",
  immunityImmPlay: "immunityImmPlay",
  immunityInsight1Title: "immunityInsight1Title",
  immunityInsight1Lead: "immunityInsight1Lead",
  immunityInsight1Body: "immunityInsight1Body",
  immunityInsight2Title: "immunityInsight2Title",
  immunityInsight2Lead: "immunityInsight2Lead",
  immunityInsight2Body: "immunityInsight2Body",
  immunityInsight3Title: "immunityInsight3Title",
  immunityInsight3Lead: "immunityInsight3Lead",
  immunityInsight3Body: "immunityInsight3Body",
  immunityImmBadgeLow: "immunityImmBadgeLow",
  immunityImmBadgeIntermediate: "immunityImmBadgeIntermediate",
  immunityImmBadgeHigh: "immunityImmBadgeHigh",
  immunityImmBadgeMildlyRaised: "immunityImmBadgeMildlyRaised",
  immunityImmBadgeNormal: "immunityImmBadgeNormal",
  // AHD-8121 — strings that shipped as hardcoded English when the LP went multilang
  immunityHeroReviewLabel: "immunityHeroReviewLabel",
  immunityCoverageCta: "immunityCoverageCta",
  immunityProcessLabel: "immunityProcessLabel",
  immunityProcessStepWord: "immunityProcessStepWord",
  immunityReportEyebrow: "immunityReportEyebrow",
  immunityReportHeading: "immunityReportHeading",
  immunityReportBody: "immunityReportBody",
  immunityReportCta: "immunityReportCta",
  immunityMembershipEyebrow: "immunityMembershipEyebrow",
  immunityMembershipHeading1: "immunityMembershipHeading1",
  immunityMembershipHeading2: "immunityMembershipHeading2",
  immunityMembershipBody: "immunityMembershipBody",
  immunityMarker1Chip1: "immunityMarker1Chip1",
  immunityMarker1Chip2: "immunityMarker1Chip2",
  immunityMarker2Chip1: "immunityMarker2Chip1",
  immunityMarker2Chip2: "immunityMarker2Chip2",
  immunityMarker3Chip1: "immunityMarker3Chip1",
  immunityMarker3Chip2: "immunityMarker3Chip2",
  immunityMarker4Chip1: "immunityMarker4Chip1",
  immunityMarker4Chip2: "immunityMarker4Chip2",
  immunityMkLymphocytes: "immunityMkLymphocytes",
  immunityMkWhiteBloodCells: "immunityMkWhiteBloodCells",
  immunityMkVitaminD: "immunityMkVitaminD",
  immunityMkHsCrp: "immunityMkHsCrp",
  immunityMkEsr: "immunityMkEsr",
  immunityMkNlr: "immunityMkNlr",
  immunityMkFerritin: "immunityMkFerritin",
  immunityMkTransferrinSat: "immunityMkTransferrinSat",
  immunityMetaTitle: "immunityMetaTitle",
  immunityMetaDescription: "immunityMetaDescription",
  immunityGpHeading: "immunityGpHeading",
  immunityGpBody: "immunityGpBody",
  immunityGpAheadTitle: "immunityGpAheadTitle",
  immunityGpAheadRow1: "immunityGpAheadRow1",
  immunityGpAheadRow2: "immunityGpAheadRow2",
  immunityGpAheadRow3: "immunityGpAheadRow3",
  immunityGpAheadRow4: "immunityGpAheadRow4",
  immunityGpAheadRow5: "immunityGpAheadRow5",
  immunityGpAheadRow6: "immunityGpAheadRow6",
  immunityGpTypicalTitle: "immunityGpTypicalTitle",
  immunityGpTypicalRow1: "immunityGpTypicalRow1",
  immunityGpTypicalRow2: "immunityGpTypicalRow2",
  immunityGpTypicalRow3: "immunityGpTypicalRow3",
  immunityGpTypicalRow4: "immunityGpTypicalRow4",
  immunityGpTypicalRow5: "immunityGpTypicalRow5",
  immunityGpTypicalRow6: "immunityGpTypicalRow6",
  immunityMembershipBenefit: "immunityMembershipBenefit",

  // ─── Heart health LP (AHD-8415) — nested under go.heart-health.* ───
  heartHealthBadgeBorderline: "heart-health.badgeBorderline",
  heartHealthBadgeHigh: "heart-health.badgeHigh",
  heartHealthBadgeNormal: "heart-health.badgeNormal",
  heartHealthBadgeRaised: "heart-health.badgeRaised",
  heartHealthCoverageBody: "heart-health.coverageBody",
  heartHealthCoverageCta: "heart-health.coverageCta",
  heartHealthCoverageEyebrow: "heart-health.coverageEyebrow",
  heartHealthCoverageHeading: "heart-health.coverageHeading",
  heartHealthCtaBody: "heart-health.ctaBody",
  heartHealthCtaCta1: "heart-health.ctaCta1",
  heartHealthCtaEyebrow: "heart-health.ctaEyebrow",
  heartHealthCtaHeading: "heart-health.ctaHeading",
  heartHealthGpAheadRow1: "heart-health.gpAheadRow1",
  heartHealthGpAheadRow2: "heart-health.gpAheadRow2",
  heartHealthGpAheadRow3: "heart-health.gpAheadRow3",
  heartHealthGpAheadRow4: "heart-health.gpAheadRow4",
  heartHealthGpAheadRow5: "heart-health.gpAheadRow5",
  heartHealthGpAheadRow6: "heart-health.gpAheadRow6",
  heartHealthGpAheadTitle: "heart-health.gpAheadTitle",
  heartHealthGpBody: "heart-health.gpBody",
  heartHealthGpHeading: "heart-health.gpHeading",
  heartHealthGpTypicalRow1: "heart-health.gpTypicalRow1",
  heartHealthGpTypicalRow2: "heart-health.gpTypicalRow2",
  heartHealthGpTypicalRow3: "heart-health.gpTypicalRow3",
  heartHealthGpTypicalRow4: "heart-health.gpTypicalRow4",
  heartHealthGpTypicalRow5: "heart-health.gpTypicalRow5",
  heartHealthGpTypicalRow6: "heart-health.gpTypicalRow6",
  heartHealthGpTypicalTitle: "heart-health.gpTypicalTitle",
  heartHealthGroupInflammation: "heart-health.groupInflammation",
  heartHealthGroupInherited: "heart-health.groupInherited",
  heartHealthGroupLipids: "heart-health.groupLipids",
  heartHealthHeroBody: "heart-health.heroBody",
  heartHealthHeroCta1: "heart-health.heroCta1",
  heartHealthHeroEyebrow: "heart-health.heroEyebrow",
  heartHealthHeroHeading: "heart-health.heroHeading",
  heartHealthHeroKpi1Label: "heart-health.heroKpi1Label",
  heartHealthHeroKpi1Value: "heart-health.heroKpi1Value",
  heartHealthHeroKpi2Label: "heart-health.heroKpi2Label",
  heartHealthHeroKpi2Value: "heart-health.heroKpi2Value",
  heartHealthHeroKpi3Label: "heart-health.heroKpi3Label",
  heartHealthHeroKpi3Value: "heart-health.heroKpi3Value",
  heartHealthHeroReviewLabel: "heart-health.heroReviewLabel",
  heartHealthImmHeading: "heart-health.immHeading",
  heartHealthImmMarkersBehind: "heart-health.immMarkersBehind",
  heartHealthImmPause: "heart-health.immPause",
  heartHealthImmPlay: "heart-health.immPlay",
  heartHealthImmReadTogether: "heart-health.immReadTogether",
  heartHealthImmSubhead: "heart-health.immSubhead",
  heartHealthMarker1Chip1: "heart-health.marker1Chip1",
  heartHealthMarker1Chip2: "heart-health.marker1Chip2",
  heartHealthMarker1Desc: "heart-health.marker1Desc",
  heartHealthMarker1Eyebrow: "heart-health.marker1Eyebrow",
  heartHealthMarker1Title: "heart-health.marker1Title",
  heartHealthMarker2Chip1: "heart-health.marker2Chip1",
  heartHealthMarker2Chip2: "heart-health.marker2Chip2",
  heartHealthMarker2Chip3: "heart-health.marker2Chip3",
  heartHealthMarker2Desc: "heart-health.marker2Desc",
  heartHealthMarker2Eyebrow: "heart-health.marker2Eyebrow",
  heartHealthMarker2Title: "heart-health.marker2Title",
  heartHealthMarker3Chip1: "heart-health.marker3Chip1",
  heartHealthMarker3Chip2: "heart-health.marker3Chip2",
  heartHealthMarker3Desc: "heart-health.marker3Desc",
  heartHealthMarker3Eyebrow: "heart-health.marker3Eyebrow",
  heartHealthMarker3Title: "heart-health.marker3Title",
  heartHealthMarker4Chip1: "heart-health.marker4Chip1",
  heartHealthMarker4Chip2: "heart-health.marker4Chip2",
  heartHealthMarker4Desc: "heart-health.marker4Desc",
  heartHealthMarker4Eyebrow: "heart-health.marker4Eyebrow",
  heartHealthMarker4Title: "heart-health.marker4Title",
  heartHealthMeasureBody: "heart-health.measureBody",
  heartHealthMeasureEyebrow: "heart-health.measureEyebrow",
  heartHealthMeasureHeading: "heart-health.measureHeading",
  heartHealthRelatedLabel: "heart-health.relatedLabel",
  heartHealthRelatedLpa: "heart-health.relatedLpa",
  heartHealthRelatedCalcium: "heart-health.relatedCalcium",
  heartHealthMetaDescription: "heart-health.metaDescription",
  heartHealthMetaTitle: "heart-health.metaTitle",
  heartHealthMkApoB: "heart-health.mkApoB",
  heartHealthMkHsCrp: "heart-health.mkHsCrp",
  heartHealthMkLdl: "heart-health.mkLdl",
  heartHealthMkLpa: "heart-health.mkLpa",
  heartHealthMkNonHdl: "heart-health.mkNonHdl",
  heartHealthMkTriglycerides: "heart-health.mkTriglycerides",
  heartHealthMriBody: "heart-health.mriBody",
  heartHealthMriCta: "heart-health.mriCta",
  heartHealthMriCtaSecondary: "heart-health.mriCtaSecondary",
  heartHealthMriEyebrow: "heart-health.mriEyebrow",
  heartHealthMriFinding1Lead: "heart-health.mriFinding1Lead",
  heartHealthMriFinding1Note: "heart-health.mriFinding1Note",
  heartHealthMriFinding1Status: "heart-health.mriFinding1Status",
  heartHealthMriFinding1Title: "heart-health.mriFinding1Title",
  heartHealthMriFinding2Lead: "heart-health.mriFinding2Lead",
  heartHealthMriFinding2Note: "heart-health.mriFinding2Note",
  heartHealthMriFinding2Status: "heart-health.mriFinding2Status",
  heartHealthMriFinding2Title: "heart-health.mriFinding2Title",
  heartHealthMriFinding3Lead: "heart-health.mriFinding3Lead",
  heartHealthMriFinding3Note: "heart-health.mriFinding3Note",
  heartHealthMriFinding3Status: "heart-health.mriFinding3Status",
  heartHealthMriFinding3Title: "heart-health.mriFinding3Title",
  heartHealthMriHeading: "heart-health.mriHeading",
  heartHealthPricingBaselineCta: "heart-health.pricingBaselineCta",
  heartHealthPricingBody: "heart-health.pricingBody",
  heartHealthPricingBodyBloodOnly: "heart-health.pricingBodyBloodOnly",
  heartHealthPricingFootnote: "heart-health.pricingFootnote",
  heartHealthPricingHeading: "heart-health.pricingHeading",
  heartHealthPricingHeadingBloodOnly: "heart-health.pricingHeadingBloodOnly",
  heartHealthPricingMriCardBadge: "heart-health.pricingMriCardBadge",
  heartHealthPricingMriCardCta: "heart-health.pricingMriCardCta",
  heartHealthPricingMriCardPriceLabel: "heart-health.pricingMriCardPriceLabel",
  heartHealthPricingMriCardTagline: "heart-health.pricingMriCardTagline",
  heartHealthPricingMriCardTitle: "heart-health.pricingMriCardTitle",
  heartHealthPricingMriPriceFrom: "heart-health.pricingMriPriceFrom",
  heartHealthPricingMriRow1: "heart-health.pricingMriRow1",
  heartHealthPricingMriRow2: "heart-health.pricingMriRow2",
  heartHealthPricingMriRow3: "heart-health.pricingMriRow3",
  heartHealthPricingMriRow4: "heart-health.pricingMriRow4",
  heartHealthProcessBody: "heart-health.processBody",
  heartHealthProcessHeading: "heart-health.processHeading",
  heartHealthProcessLabel: "heart-health.processLabel",
  heartHealthProcessStep1Desc: "heart-health.processStep1Desc",
  heartHealthProcessStep1Title: "heart-health.processStep1Title",
  heartHealthProcessStep2Desc: "heart-health.processStep2Desc",
  heartHealthProcessStep2Title: "heart-health.processStep2Title",
  heartHealthProcessStep3Desc: "heart-health.processStep3Desc",
  heartHealthProcessStep3Title: "heart-health.processStep3Title",
  heartHealthProcessStep4Desc: "heart-health.processStep4Desc",
  heartHealthProcessStep4Title: "heart-health.processStep4Title",
  heartHealthProcessStepWord: "heart-health.processStepWord",
  heartHealthReportBody: "heart-health.reportBody",
  heartHealthReportCta: "heart-health.reportCta",
  heartHealthReportEyebrow: "heart-health.reportEyebrow",
  heartHealthReportHeading: "heart-health.reportHeading",
  heartHealthSign1Desc: "heart-health.sign1Desc",
  heartHealthSign1Title: "heart-health.sign1Title",
  heartHealthSign2Desc: "heart-health.sign2Desc",
  heartHealthSign2Title: "heart-health.sign2Title",
  heartHealthSign3Desc: "heart-health.sign3Desc",
  heartHealthSign3Title: "heart-health.sign3Title",
  heartHealthSign4Desc: "heart-health.sign4Desc",
  heartHealthSign4Title: "heart-health.sign4Title",
  heartHealthSign5Desc: "heart-health.sign5Desc",
  heartHealthSign5Title: "heart-health.sign5Title",
  heartHealthSign6Desc: "heart-health.sign6Desc",
  heartHealthSign6Title: "heart-health.sign6Title",
  heartHealthSignsBody: "heart-health.signsBody",
  heartHealthSignsEyebrow: "heart-health.signsEyebrow",
  heartHealthSignsHeading: "heart-health.signsHeading",
  heartHealthStory1Body: "heart-health.story1Body",
  heartHealthStory1Lead: "heart-health.story1Lead",
  heartHealthStory1Title: "heart-health.story1Title",
  heartHealthStory2Body: "heart-health.story2Body",
  heartHealthStory2Lead: "heart-health.story2Lead",
  heartHealthStory2Title: "heart-health.story2Title",
  heartHealthStory3Body: "heart-health.story3Body",
  heartHealthStory3Lead: "heart-health.story3Lead",
  heartHealthStory3Title: "heart-health.story3Title",
  heartHealthWedgeBody: "heart-health.wedgeBody",
  heartHealthWedgeHeading1: "heart-health.wedgeHeading1",
  heartHealthWedgeHeading2: "heart-health.wedgeHeading2",
} as const
